import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-296">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-297">
          <div className="bg-[#122618] rounded-xl shadow-2xl border border-[#2c4c3b] p-4 pr-10 relative overflow-hidden" data-id="element-298">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#d4af37]" data-id="element-299"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-[#cbd5e1] hover:text-white p-1" aria-label="Cerrar notificación" data-id="element-300">
              <X className="w-4 h-4" data-id="element-301" />
            </button>

            <div className="flex items-start gap-3" data-id="element-302">
              <div className="mt-0.5 shrink-0" data-id="element-303">
                <CheckCircle2 className="w-5 h-5 text-[#d4af37]" data-id="element-304" />
              </div>
              <div data-id="element-305">
                <p className="text-xs font-bold text-[#d4af37] uppercase tracking-wider mb-1" data-id="element-306">
                  Compra verificada
                </p>
                <p className="text-sm text-[#fdfbf7] leading-tight" data-id="element-307">
                  <strong data-id="element-308">María R.</strong> de Córdoba compró
                  <br data-id="element-309" />
                  <span className="text-[#cbd5e1] font-medium" data-id="element-310">
                    MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360 🌾🇦🇷
                  </span>
                </p>
                <p className="text-xs text-[#8b9fb0] mt-2" data-id="element-311">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}